// ═══════════════════════════════════════════════════════════════
//  SITE DETAILS — your contact info and social links
//  These show in the red contact section and the footer.
//
//  TO EDIT: change the text between the "quotes"
//  Social links: leave as "" to hide that icon completely
// ═══════════════════════════════════════════════════════════════

export const siteSettings = {
  // Your email — shown on the website (form enquiries are emailed
  // through Web3Forms to the address on your Web3Forms account)
  notification_email: "Strovyn@gmail.com",

  // Your phone numbers — leave phone2 as "" if you only have one
  phone1: "0406 646 061",
  phone2: "0481 783 135",

  // Shown as your location on the site
  location: "Adelaide, South Australia",

  // Social links — "" means hidden
  instagram: "https://www.instagram.com/strovyn.official",
  facebook: "facebook.com/strovyn.official",
  tiktok: "tiktok.com/@strovyn.official",
  linkedin: "linkedin.com/company/strovyn",
};
